import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KpmgTaxUiModule } from '@kpmg-tax/ui';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RightSideDrawerComponent } from './right-side-drawer';
import { AddAnEmployeeFormComponent } from './right-side-drawer/add-an-employee-form/add-an-employee-form.component';
import { EiEditSingleEmployeeComponent } from './right-side-drawer/ei-edit-single-employee/ei-edit-single-employee.component';
import { HomeEditAnEngagementComponent } from './right-side-drawer/home-edit-an-engagement/home-edit-an-engagement.component';
import { ClientNameBannerComponent } from './client-name-banner/client-name-banner.component';
import { EpAddActivityComponent } from './right-side-drawer/ep-add-activity/ep-add-activity.component';
import { EpEditActivityComponent } from './right-side-drawer/ep-edit-activity/ep-edit-activity.component';
import { EiDeleteSingleEmployeeComponent } from './right-side-drawer/ei-delete-single-employee/ei-delete-single-employee.component';
import { EiDeleteMultipleEmployeeComponent } from './right-side-drawer/ei-delete-multiple-employee/ei-delete-multiple-employee.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { FileLoaderComponent } from './file-service/file-loader.component';
import { EpAddProjectsComponent } from './right-side-drawer/ep-projects/ep-add-projects.component';
import { AssignSurveyRepondentComponent } from './right-side-drawer/assign-survey-respondent/assign-survey-respondent.component';
import { CommentsComponent } from './right-side-drawer/comments/comments.component';
import { AddActivitiesComponent } from './right-side-drawer/aa-add-activities/add-activities-component';
import { AddProjectsComponent } from './right-side-drawer/aa-add-projects/add-projects-component';
import { TimeSurveyEmployeeList } from './right-side-drawer/time-survey-employee/time-survey-employee-list.component';
import { EiRecordsComponent } from './right-side-drawer/ei-records/ei-records.component';
import { AddUpdateMasterActivityComponent } from './right-side-drawer/add-update-master-activities/add-update-activity.component';
import { AdminNavigationComponent } from './navigation/admin-nav/admin-nav.component';
import { ConfirmationBoxComponent } from './right-side-drawer/confirmation-box/confirmation-box.component';
import { AddUserComponent } from './right-side-drawer/add-user/add-user-component';
import { toLocalDatePipe } from '../core/pipes/local-date-format.pipes';
import { ClickOutsideDirective } from '../core/directives/clickoutside.directive';
import { NumericCheckDirective } from '../core/directives/numericheck.directive';
import { AddUserModelComponent } from './add-user-model/add-user-model.component';
import { savechangesconfirmationComponent } from './savechanges-confirmation/savechanges-confirmation.component';
import { AssignBulkSurveyToSMEComponent } from './right-side-drawer/assign-bulk-SMEs/assign-bulk-sme.component';
import { AddClientUserComponent } from './right-side-drawer/add-client-user/add-client-user-component';
import { ReportsNavigationComponent } from './navigation/reports-nav/reports-nav.component';
import { TopNavigationComponent } from './navigation/top-navbar/top-nav.component';
import { UserMenuComponent } from '../core';
import { EditExpenseSurveyComponent } from './right-side-drawer/edit-expense-survey/edit-expense-survey.component';
import { NgxTableColumnFilterComponent } from './ngx-table-column-filter/ngx-table-column-filter.component';
import { MultipleSelectFilterComponent } from './ngx-table-column-filter/multiple-select-filter/multiple-select-filter.component';
import { TextFilterComponent } from './ngx-table-column-filter/text-filter/text-filter.component';
import * as excelIO from '@grapecity/spread-excelio';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CreateStudyComponent } from './right-side-drawer/create-study/create-study.component';
import { SessionMgmtComponent } from './session-mgmt';
import { ActivityMonitorComponent } from './activity-monitor';
import { StorageMonitorComponent } from './storage-monitor';
import { TopNavBarLeftComponent } from './navigation/top-navbar-left/top-navbar-left.component';
import { TopNavBarRightComponent } from './navigation/top-navbar-right/top-navbar-right.component';
import { TopNavBarCenterComponent } from './navigation/top-navbar-center/top-navbar-center.component';
import { SpinnerComponent } from './right-side-drawer/spinner/spinner.component';
import { ModalService } from './modal/modal.service';
import { ExpenseSubmitHistoryComponent } from './right-side-drawer/expense-submit-history/expense-submit-history.component';
import { ExpenseDetailEditComponent } from './right-side-drawer/expense-detail-edit/expense-detail-edit.component';
import { ExpenseSurveyCommentComponent } from './right-side-drawer/expense-survey-comment/expense-survey-comment.component';
import { ClientManagerViewComponent } from './client-manager-view/client-manager-view.component';
import { StudyNameTemplate } from './study-name-template/study-name-template.component';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { EmailComponent } from './right-side-drawer/email/email.component';
import { CustomUploaderComponent } from './custom-uploader/custom-uploader.component';
import { OnlynumberDirective } from '../core/directives/onlynumber.directive';
import { ClientSmeViewComponent } from './client-sme-view/client-sme-view.component';
import { SurveyDocumentComponent } from './survey-document/survey-document.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { UploadedFileListComponent } from './uploaded-file-list/uploaded-file-list.component';
import { ClientUserManagementComponent } from './client-usermanagement/client-usermanagement.component';
import { EmailTipsModal } from 'src/app/shared/modal/EmailTips/email-tips-modal.component';
import { TaxYearQreComponent } from './tax-year-qre/tax-year-qre.component';
import { AddAnEntityComponent } from './right-side-drawer/add-an-entity/add-an-entity.component';
import { EditAnEntityComponent } from './right-side-drawer/edit-an-entity/edit-an-entity.component';
import { ReleaseBannerComponent } from 'src/app/shared/release-banner/release-banner-component';
import { ManageBusinessComponent } from '../data-analysis-summary/business-component/manage-business-component/manage-business-component-screen.component';
import { DeleteBusinessCompDialog } from '../data-analysis-summary/business-component/delete-business-comp/delete-business-comp.component';
import { AddExistingClientProjDialog } from '../data-analysis-summary/business-component/add-existing-project/add-existing-project.component';
import { CreateBusinessComponent } from '../data-analysis-summary/business-component/create-business-component/create-business-component.component';
import { BusinessComponentConfirmDialog } from './right-side-drawer/bc-upload-confirm-dialog/bc-upload-confirm-dialog.component';
import { EditClientProjectComponent } from '../data-analysis-summary/business-component/edit-client-project/edit-client-project.component';
import { RemoveProjectFromBusinessComp } from '../data-analysis-summary/business-component/remove-project-manageBC/remove-project-manageBC.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        KpmgTaxUiModule,
        NgxDatatableModule,
        TooltipModule,
        BsDatepickerModule.forRoot(),
        AngularEditorModule,
        NgMultiSelectDropDownModule.forRoot()
    ],
    declarations: [
        ClientUserManagementComponent,
        RightSideDrawerComponent,
        AddAnEmployeeFormComponent,
        EiEditSingleEmployeeComponent,
        CreateStudyComponent,
        HomeEditAnEngagementComponent,
        ClientNameBannerComponent,
        EpAddActivityComponent,
        EpEditActivityComponent,
        EiDeleteSingleEmployeeComponent,
        EiDeleteMultipleEmployeeComponent,
        ToggleSwitchComponent,
        FileLoaderComponent,
        EpAddProjectsComponent,
        AssignSurveyRepondentComponent,
        CommentsComponent,
        AssignSurveyRepondentComponent,
        AddActivitiesComponent,
        AddProjectsComponent,
        TimeSurveyEmployeeList,
        EiRecordsComponent,
        AddUpdateMasterActivityComponent,
        AdminNavigationComponent,
        ConfirmationBoxComponent,
        AddUserComponent,
        AddClientUserComponent,
        toLocalDatePipe,
        ClickOutsideDirective,
        NumericCheckDirective,
        OnlynumberDirective,
        AddUserModelComponent,
        savechangesconfirmationComponent,
        AssignBulkSurveyToSMEComponent,
        ReportsNavigationComponent,
        TopNavigationComponent,
        UserMenuComponent,
        EditExpenseSurveyComponent,
        NgxTableColumnFilterComponent,
        MultipleSelectFilterComponent,
        TextFilterComponent,
        SessionMgmtComponent,
        ActivityMonitorComponent,
        StorageMonitorComponent,
        TopNavBarLeftComponent,
        TopNavBarRightComponent,
        TopNavBarCenterComponent,
        SpinnerComponent,
        ExpenseSubmitHistoryComponent,
        ExpenseDetailEditComponent,
        ExpenseSurveyCommentComponent,
        ClientManagerViewComponent,
        ClientSmeViewComponent,
        StudyNameTemplate,
        CustomDropdownComponent,
        EmailComponent,
        CustomUploaderComponent,
        SurveyDocumentComponent,
        UploadedFileListComponent,
        EmailTipsModal,
        TaxYearQreComponent,
        AddAnEntityComponent,
        EditAnEntityComponent,
        ReleaseBannerComponent,
        ManageBusinessComponent,
        DeleteBusinessCompDialog,
        AddExistingClientProjDialog,
        CreateBusinessComponent,
        BusinessComponentConfirmDialog,
        EditClientProjectComponent,
        RemoveProjectFromBusinessComp
    ],
    providers: [
        DatePipe,
        ModalService,
        excelIO.IO
    ],
    exports: [
        StudyNameTemplate,
        RightSideDrawerComponent,
        AddAnEmployeeFormComponent,
        EiEditSingleEmployeeComponent,
        EiDeleteMultipleEmployeeComponent,
        ClientNameBannerComponent,
        ToggleSwitchComponent,
        FileLoaderComponent,
        EpAddProjectsComponent,
        CommentsComponent,
        AssignSurveyRepondentComponent,
        EiRecordsComponent,
        AdminNavigationComponent,
        ConfirmationBoxComponent,
        ClickOutsideDirective,
        NumericCheckDirective,
        OnlynumberDirective,
        AddUserModelComponent,
        savechangesconfirmationComponent,
        AssignBulkSurveyToSMEComponent,
        HomeEditAnEngagementComponent,
        ReportsNavigationComponent,
        TopNavigationComponent,
        UserMenuComponent,
        NgxTableColumnFilterComponent,
        SessionMgmtComponent,
        ActivityMonitorComponent,
        StorageMonitorComponent,
        ClientManagerViewComponent,
        ClientSmeViewComponent,
        CustomDropdownComponent,
        CustomUploaderComponent,
        SurveyDocumentComponent,
        EmailTipsModal,
        TaxYearQreComponent,
        ReleaseBannerComponent,
        ManageBusinessComponent,
        DeleteBusinessCompDialog,
        AddExistingClientProjDialog,
        CreateBusinessComponent,
        BusinessComponentConfirmDialog,
        EditClientProjectComponent,
        RemoveProjectFromBusinessComp
    ],
    entryComponents: [
        RightSideDrawerComponent,
        UserMenuComponent
    ]
})
export class SharedModule { }
